import { NextRouter } from 'next/router';
import { Routes } from 'constants/routes';

export function resolveSearchPageQuery(
  router: NextRouter,
  searchText?: string,
  initialSearchQuery?: string | null
): string {
  const fromRouter = router.query.q?.toString() ?? router.query.q3?.toString();

  if (fromRouter) {
    return decodeURIComponent(fromRouter);
  }

  if (searchText?.trim()) {
    return searchText;
  }

  if (initialSearchQuery?.trim()) {
    return initialSearchQuery;
  }

  return '';
}

export function syncShallowSearchUrl(
  router: NextRouter,
  pathname: string,
  value: string,
  param: string
) {
  if (router.pathname !== pathname) {
    return;
  }

  const current = router.query[param]?.toString() ?? '';
  const next = value.trim();

  if (next) {
    if (next === current) {
      return;
    }

    void router.push(
      `${pathname}?${param}=${encodeURIComponent(next)}`,
      undefined,
      { shallow: true }
    );
    return;
  }

  if (current) {
    void router.push(pathname, undefined, { shallow: true });
  }
}

// Search dropdowns show only the top matches; the rest is on the search page
const DROPDOWN_LIMIT = 5;
const DROPDOWN_SLOTS_LIMIT = 10;

export function getDropdownSearchParams(variant?: string) {
  if (variant === 'slots') {
    return { type: 'slots', limit: DROPDOWN_SLOTS_LIMIT };
  }

  return { type: 'casinos,slots,streamers', limit: DROPDOWN_LIMIT };
}

export function getDropdownAllResults(
  search: string,
  counts: Partial<Record<string, number>> | undefined,
  variant?: string
) {
  if (!counts || variant === 'streamer') {
    return undefined;
  }

  const count =
    variant === 'slots'
      ? (counts.slots ?? 0)
      : (counts.casinos ?? 0) + (counts.slots ?? 0) + (counts.streamers ?? 0);

  return {
    href: `${Routes.search}?q3=${encodeURIComponent(search)}`,
    count,
  };
}
